import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserGetResponse } from '../../../shared/types/user/user-get-response';
@Component({
  selector: 'wsd-user-list-grid',
  templateUrl: './user-list-grid.component.html',
  styleUrls: ['./user-list-grid.component.css']
})
export class UserListGridComponent {

  private _users = new BehaviorSubject<UserGetResponse>(null);

  @Output() public onPageChangeEvent = new EventEmitter();

  @Input() public pageSize: number;
  @Input()
  set users(value) {
    this._users.next(value);
  }

  get users(): UserGetResponse {
    return this._users.getValue();
  }

  constructor() { }

  public onPageChange(event) {
    this.onPageChangeEvent.emit(event);
  }

  public separateRoles(roles) {
    const list = roles.split(',');
    return list;
  }

  public modifyUser(user) {
    window.open(user.link);
  }


}
